<template>
    <div style="opacity: 0; position: fixed; left: 9999px; top: 0; zIndex: -9999;">
        <div v-for="(print, index) in finalPrints" :key="index">
            <!-- 分页 -->
            <div v-if="print[listKey].length > rows">
                <div v-for="(p, idx) in getPages(print[listKey])" :key="idx">
                    <print-form class="print-form" :identify="identify" :layout="layout" :print="print" :list="p" :pages="getPages(print[listKey]).length || 1" :page="idx + 1" :mock="false"></print-form>
                </div>
            </div>
            <!-- 单页 -->
            <div v-else>
                <print-form class="print-form" :identify="identify" :layout="layout" :print="print" :list="print[listKey]" :pages="1" :page="1" :mock="false"></print-form>
            </div>
        </div>
    </div>
</template>

<script>
import PrintForm from '@/components/web/xtsz/dymbsz/mblb/PrintForm.vue';
// import html2canvas from 'html2canvas';
// import printjs from 'print-js';
import { Printd } from './printer.js'

export default {
    props: {
        // 打印模板布局
        layout: {
            type: Object,
            default: () => ({}),
        },
        // 打印多条数据
        prints: {
            type: Array,
            default: () => [],
        },
        // 单条数据列表key(比如wupins)
        listKey: {
            type: String,
            default: '',
        },
        // 标识(区分同一页面不同Printer)
        // 比如同一页面不同tab页下的Printer
        identify: {
            type: String,
            default: ''
        },
        sortStr: {
            type: String,
            default: ''
        }
    },
    components: {
        PrintForm,
    },
    data() {
        return {
            printer: null,
            cssText: `
                .printer * {
                    font-family: "Microsoft YaHei", Arial, sans-serif !important;
                    -webkit-font-smoothing: antialiased !important;
                    -webkit-text-size-adjust: 100%;
                    text-size-adjust: 100%;
                    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                    font-variant: tabular-nums;
                    color: #000 !important;
                    -webkit-font-feature-settings: 'tnum', "tnum";
                    font-feature-settings: 'tnum', "tnum";
                }
                .print-ellipsis {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .print-addr {
                    height: 2.5em !important;
                    line-height: 1.25em !important;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                    white-space: inherit;
                }
                .vxe-table .vxe-table--body-wrapper {
                    overflow: hidden !important;
                }
                .vxe-table .vxe-header--column .vxe-resizable {
                    opacity: 0 !important;
                }
                .vxe-table .vxe-header--column,
                .vxe-table .vxe-body--column {
                    color: #000 !important;
                    padding: 0 !important;
                    border: none;
                    box-sizing: border-box;
                    text-align: center !important;
                    border-right: 1px solid #000 !important;
                    border-top: 1px solid #000 !important;
                }
                .vxe-table .vxe-header--column {
                    border-top: 1px solid #000 !important;
                }
                .vxe-table .vxe-header--column:last-child,
                .vxe-table .vxe-body--column:last-child {
                    border-right: 1px solid #000 !important;
                }
                .vxe-table .vxe-cell {
                    padding: 0;
                    overflow: hidden !important;
                    text-align: center !important;
                    white-space: nowrap !important;
                    box-sizing: border-box;
                }
                .table-thin .vxe-table .vxe-header--column,
                .table-thin .vxe-table .vxe-body--column,
                .table-thin .vxe-table .vxe-cell {
                    height: 4.5mm !important;
                    line-height: 4.5mm !important;
                }
                .vxe-table .vxe-header--column:first-child,
                .vxe-table .vxe-body--column:first-child{
                    border-left: 1px solid #000 !important;
                }
                .vxe-table .vxe-body--row:first-child .vxe-body--column {
                    border-top: 1px solid #000 !important;
                }
                .vxe-table .vxe-body--row:last-child .vxe-body--column {
                    border-bottom: 1px solid #000 !important;
                }
                .table-empty .vxe-table .vxe-header--column {
                    border-bottom: 1px solid #000 !important;
                }
                .table-12px * {
                    font-size: 12px !important;
                }
                .table-13px * {
                    font-size: 13px !important;
                }
                .table-14px * {
                    font-size: 14px !important;
                }
                .table-15px * {
                    font-size: 15px !important;
                }
                .table-16px * {
                    font-size: 16px !important;
                }
            `
        }
    },
    computed: {
        rows() {
            return this.layout ? this.layout.meiyebiaogehangshu : 10;
        },
        finalPrints() {
            return Array.from(this.prints, (o) => ({
                ...o,
                [this.listKey]: this.getList(o[this.listKey])
            }))
        }
    },
    mounted() {
        this.printer = Printd.getInstance()
    },
    methods: {
        isSortByCatetory(e) {
            return [
                '按物品类别名称字母升序+物品编码升序',
                '按物品类别名称字母升序+物品名称字母升序',
                '按物品类别顺序+物品单位顺序'
            ].includes(e)
        },
        async print() {
            // 获取要打印的NodeList
            // [...html] 将NodeList转化为Array(NodeList没有map方法)
            const nodes = document.querySelectorAll('.printer' + (this.identify || ''));
            setTimeout(() => {
                const callback = ({ launchPrint, iframe }) => {
                    const { contentWindow } = iframe
                    contentWindow.onafterprint = () => {
                        this.$emit('on-close')
                    }
                    launchPrint()
                }
                this.printer.prints(nodes, ['https://img.weizhilian.com/fe_static/vxe-table_3.5.6_lib_style.css',this.cssText], null, callback)
            }, 100)
        },
        // 排序规则
        sortWord(a, b, locale = 'zh-Hans-CN') {
            return a.localeCompare(b, locale, {sensitivity: 'accent'})
        },
        // 物品排序
        sortWupin(list, type) {
            if (type === '按单据物品排序' || type === '按物品类别顺序+物品单位顺序' || !type) {
                // 接口排序
                return list
            } else if (type === '按物品类别名称字母升序+物品编码升序') {
                // 分类 + code
                return list.sort((a, b) => {
                    if (this.sortWord(a.leibieStr, b.leibieStr) === 0) {
                        return this.sortWord(a.code, b.code, 'en')
                    } else {
                        return this.sortWord(a.leibieStr, b.leibieStr)
                    }
                })
            } else if (type === '按物品类别名称字母升序+物品名称字母升序') {
                // 分类 + name
                return list.sort((a, b) => {
                    if (this.sortWord(a.leibieStr, b.leibieStr) === 0) {
                        return this.sortWord(a.name, b.name)
                    } else {
                        return this.sortWord(a.leibieStr, b.leibieStr)
                    }
                })
            } else if (type === '按物品编码升序') {
                // code
                return list.sort((a, b) => this.sortWord(a.code, b.code, 'en'))
            } else if (type === '按物品名称首字母升序') {
                // name
                return list.sort((a, b) => this.sortWord(a.name, b.name))
            } else {
                return list
            }
        },
        // 数组根据属性分组
        groupByProperty(arr, property) {
            return arr.reduce(function (acc, obj) {
                const key = obj[property];
                if (!acc[key]) {
                acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
            }, {});
        },
        // 属性分组转数组
        groupToArray(arr, property) {
            const groups = this.groupByProperty(arr, property);
            return Object.values(groups);
        },
        // 数组根据数量分组
        groupByCount(arr, count) {
            return Array.from({ length: Math.ceil(arr.length / count) }, (_, index) => arr.slice(index * count, index * count + count))
        },
        // 获取打印列表
        getList(list) {
            const { wupinpaixu = '', fenleixiaoji = '不展示', hebinghang = 'false' } = this.layout
            const isCategoryTotal = String(fenleixiaoji) === '展示'
            const isPageTotal = String(hebinghang) === 'true'
            let finalList = this.sortWupin(list, wupinpaixu)
            // 物品排序
            if (wupinpaixu) {
                // 分类小计
                if (this.isSortByCatetory(wupinpaixu) && isCategoryTotal) {
                    // 按分类分组
                    finalList = this.groupToArray(finalList, 'leibieStr')
                    finalList = finalList.reduce((a, c) => {
                        const category = this.getTotal(c, {
                            isTotal: true,
                            totalName: '分类小计',
                            leibieStr: ''
                        })
                        return [...a, ...c, category]
                    }, [])
                }
            }
            // 分页小计
            if (isPageTotal) {
                finalList = this.groupByCount(finalList, this.layout.meiyebiaogehangshu - 1)
                finalList = finalList.reduce((a, c) => {
                    const pager = this.getTotal(c, {
                        isTotal: true,
                        totalName: '合计',
                        leibieStr: ''
                    })
                    if (c.some((o) => !o.isTotal)) {
                        c.push(pager)
                    }
                    return [...a, ...c]
                }, [])
            }
            // 处理序号
            let idx = 1
            finalList.forEach((o) => {
                if (!o.isTotal) {
                    o.xuhao = idx
                    idx += 1
                }
            })
            return finalList
        },
        // 分页
        getPages(list) {
            return list.reduce((arr, item, idx) => {
                return idx % this.rows === 0 ? [...arr, [item]] : [...arr.slice(0, -1), [...arr.slice(-1)[0], item]];
            }, []);
        },
        isNotNumber(amount) {
            return Number.isNaN(parseFloat(amount))
        },
        // 汇总计算
        getTotal(list, base) {
            const danjuleixing = this.layout.danjuleixing
            if (danjuleixing === '配送发货单') {
                base.fahuoshuliang = 0
                base.fahuoshuliangkucun = 0
                base.fahuojinehanshui = 0
            } else if (danjuleixing === '配送收货单') {
                base.shouhuoshuliang = 0
                base.shouhuojinehanshui = 0
            } else if (danjuleixing === '配送订单') {
                base.caigoushuliang = 0
                base.kucunshuliang = 0
                base.caigoujinehanshui = 0
            } else if (danjuleixing === '配送返货单') {
                base.tuihuoshuliang = 0
                base.tuihuojinehanshui = 0
            } else if (danjuleixing === '采购订单') {
                base.caigoushuliang = 0
                base.caigoujinehanshui = 0
            } else if (danjuleixing === '采购收货') {
                base.shouhuoshuliang = 0
                base.shouhuojinehanshui = 0
                base.yishouhuojinehanshui = 0
            } else if (danjuleixing === '收发货差异处理单') {
                base.chayishuliang = 0
                base.chayijinehanshui = 0
            }
            return list.reduce((a, c) => {
                if (c.isTotal) {
                    return a
                }
                if (danjuleixing === '配送发货单') {
                    a.fahuoshuliang += (c.fahuoshuliang || 0)
                    a.fahuoshuliangkucun += (c.fahuoshuliangkucun || 0)
                    if (this.isNotNumber(a.fahuojinehanshui) || this.isNotNumber(c.fahuojinehanshui)) {
                        a.fahuojinehanshui = a.fahuojinehanshui || c.fahuojinehanshui
                    } else {
                        a.fahuojinehanshui = parseFloat((a.fahuojinehanshui + parseFloat((c.fahuojinehanshui || 0).toFixed(2))).toFixed(8))
                    }
                } else if (danjuleixing === '配送收货单') {
                    a.shouhuoshuliang += (c.shouhuoshuliang || 0)
                    if (this.isNotNumber(a.shouhuojinehanshui) || this.isNotNumber(c.shouhuojinehanshui)) {
                        a.shouhuojinehanshui = a.shouhuojinehanshui || c.shouhuojinehanshui
                    } else {
                        a.shouhuojinehanshui = parseFloat((a.shouhuojinehanshui + parseFloat((c.shouhuojinehanshui || 0).toFixed(2))).toFixed(8))
                    }
                } else if (danjuleixing === '配送订单') {
                    a.caigoushuliang += (c.caigoushuliang || 0)
                    a.kucunshuliang += (c.kucunshuliang || 0)
                    if (this.isNotNumber(a.caigoujinehanshui) || this.isNotNumber(c.caigoujinehanshui)) {
                        a.caigoujinehanshui = a.caigoujinehanshui || c.caigoujinehanshui
                    } else {
                        a.caigoujinehanshui = parseFloat((a.caigoujinehanshui + parseFloat((c.caigoujinehanshui || 0).toFixed(2))).toFixed(8))
                    }
                } else if (danjuleixing === '配送返货单') {
                    a.tuihuoshuliang += (c.tuihuoshuliang || 0)
                    if (this.isNotNumber(a.tuihuojinehanshui) || this.isNotNumber(c.tuihuojinehanshui)) {
                        a.tuihuojinehanshui = a.tuihuojinehanshui || c.tuihuojinehanshui
                    } else {
                        a.tuihuojinehanshui = parseFloat((a.tuihuojinehanshui + parseFloat((c.tuihuojinehanshui || 0).toFixed(2))).toFixed(8))
                    }
                } else if (danjuleixing === '采购订单') {
                    a.caigoushuliang += (c.caigoushuliang || 0)
                    if (this.isNotNumber(a.caigoujinehanshui) || this.isNotNumber(c.caigoujinehanshui)) {
                        a.caigoujinehanshui = a.caigoujinehanshui || c.caigoujinehanshui
                    } else {
                        a.caigoujinehanshui = parseFloat((a.caigoujinehanshui + parseFloat((c.caigoujinehanshui || 0).toFixed(2))).toFixed(8))
                    }
                } else if (danjuleixing === '采购收货') {
                    a.shouhuoshuliang += (c.shouhuoshuliang || 0)
                    if (this.isNotNumber(a.shouhuojinehanshui) || this.isNotNumber(c.shouhuojinehanshui)) {
                        a.shouhuojinehanshui = a.shouhuojinehanshui || c.shouhuojinehanshui
                    } else {
                        a.shouhuojinehanshui = parseFloat((a.shouhuojinehanshui + parseFloat((c.shouhuojinehanshui || 0).toFixed(2))).toFixed(8))
                    }
                    if (this.isNotNumber(a.yishouhuojinehanshui) || this.isNotNumber(c.yishouhuojinehanshui)) {
                        a.yishouhuojinehanshui = a.yishouhuojinehanshui || c.yishouhuojinehanshui
                    } else {
                        a.yishouhuojinehanshui = parseFloat((a.yishouhuojinehanshui + parseFloat((c.yishouhuojinehanshui || 0).toFixed(2))).toFixed(8))
                    }
                } else if (danjuleixing === '收发货差异处理单') {
                    a.chayishuliang += (c.chayishuliang || 0)
                    if (this.isNotNumber(a.chayijinehanshui) || this.isNotNumber(c.chayijinehanshui)) {
                        a.chayijinehanshui = a.chayijinehanshui || c.chayijinehanshui
                    } else {
                        a.chayijinehanshui = parseFloat((a.chayijinehanshui + parseFloat((c.chayijinehanshui || 0).toFixed(2))).toFixed(8))
                    }
                }
                return a
            }, {
                ...base
            })
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/components/common/Printer.vue?533245ea